import { useQuery } from '@tanstack/react-query'
import { useCreateIssuingSetupIntentMutation, useResponseNotification } from '@alice-financial/alice-sdk'

/**
 * This is kind of cheating because we're wrapping a mutation in useQuery, but in this case the mutation
 * is creating a value that we need as soon as the owner is loaded.
 */
export const useIssuingClientSecret = (
  stripeCompanyAccountId: number | null | undefined,
  stripePaymentMethodId: string | null | undefined
) => {
  const { mutateAsync: createSetupIntent } = useCreateIssuingSetupIntentMutation({})
  const { notifyError } = useResponseNotification()
  const genericError = 'Could not configure Stripe payment method. Please refresh and try again.'

  return useQuery(
    ['createIssuingSetupIntent', stripeCompanyAccountId, stripePaymentMethodId],
    async () => {
      if (!stripeCompanyAccountId) {
        throw new Error(genericError)
      }
      const response = await createSetupIntent({
        input: {
          stripeCompanyAccountId,
          stripePaymentMethodId,
        },
      })
      if (!response.createIssuingSetupIntent?.clientSecret) {
        throw new Error(genericError)
      }
      return response.createIssuingSetupIntent.clientSecret
    },
    {
      enabled: stripeCompanyAccountId != null,
      onError: (error: Error) => {
        notifyError(error.message)
      },
    }
  )
}
useIssuingClientSecret.getKey = (stripeCompanyAccountId: number, stripePaymentMethodId?: string | null) => [
  'createIssuingSetupIntent',
  stripeCompanyAccountId,
  stripePaymentMethodId,
]
